// Vue
import { Component, Prop, Vue } from "vue-property-decorator";
// Template
import template from "./template.vue";

import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import ModuleBase from "#/common/ModuleBase";
import KonsiItem from "./konsi_item/KonsiItem";
import KonsiDetailLayer from "./konsi_detail_layer/KonsiDetailLayer";
import { LoadMoreButton } from "../../../components/load_more_button/LoadMoreButton";
import { FilterModule } from "../filter_module/FilterModule";

import { Api } from "#/api";
import { Pagination } from "#/common/interfaces/conversionworld/Pagination";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    KonsiItem,
    LoadMoreButton,
    KonsiDetailLayer,
    FilterModule,
  },
})
export class KonsiListModule extends ModuleBase {
  private konsiProducts: any[] = [];
  private pagination: Pagination | null = null;
  private currentPage = 1;
  public morePages = false;
  public isLoadingMore = false;
  public openKonsiDetail = false;
  public konsiItem;

  public getBackgroundColorFromInstance(instance: object) {
    return "black";
  }

  get pageCount() {
    return this.pagination ? this.pagination.page_count : 0;
  }

  get total() {
    return this.pagination ? this.pagination.total_count : 0;
  }

  get filterInstance() {
    return {
      mode: "",
      translation: this.instance["filter"],
    };
  }

  created() {
    this.getProducts(this.currentPage);
    this.$eventBus.$on("conversion-world-close-filter", this.handleCloseFilter);
  }

  public beforeDestroy() {
    this.$eventBus.$off(
      "conversion-world-close-filter",
      this.handleCloseFilter
    );
  }

  public loadMore() {
    this.isLoadingMore = true;
    this.currentPage += 1;
    this.getProducts(this.currentPage);
  }

  public async getProducts(paginationPage) {
    let productId =
      this.$store.page.page!.route_parameter["productId"] || undefined;

    let konsi = await Api.conversionWorldService.getKonsiProducts(
      this.$store.conversionWorldKonsiFilter.filter,
      paginationPage,
      this.instance["amount"] || 3
    );

    this.pagination = konsi.pagination!;
    if (paginationPage == 1) {
      this.konsiProducts = konsi.resultList;
    } else {
      this.konsiProducts = this.konsiProducts.concat(konsi.resultList);
    }

    this.isLoadingMore = false;
    this.morePages = this.currentPage < this.pageCount!;
  }

  public handleOpenDetail(item) {
    this.openKonsiDetail = !this.openKonsiDetail;
    this.$store.ui.setShowProductComparison(this.openKonsiDetail);
    this.konsiItem = item;
  }

  public handleCloseFilter() {
    this.currentPage = 1;
    this.getProducts(1);
  }
}
